export default __webpack_public_path__ + "static/media/mis-sold.a800642b.jpg";